<template>
    <div class="bg-white px-8 pt-6 pb-8 flex flex-col my-2">


        <img  alt="school logo" src="https://www.qries.com/images/banner_logo.png" class="object-contain h-30 w-30 mb-6">

        <span class="block w-full text-xl  font-bold mb-4">Edit my Info</span>


        <div  class="mb-6">

            <div class="-mx-3 md:flex mb-6">

                <div class="md:w-1/2 px-3 mb-6 md:mb-0">
                    <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="grid-title">
                        Title
                    </label>
                    <input class="appearance-none block w-full bg-grey-lighter text-grey-darker border
                    rounded py-3 px-4 mb-3" id="grid-title" type="text" placeholder="Ms" v-model="user.title">
                </div>

                <div class="md:w-1/2 px-3">
                    <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="grid-first-name">
                        First Name
                    </label>
                    <input class="appearance-none block w-full bg-grey-lighter text-grey-darker border border-grey-lighter
                     rounded py-3 px-4" id="grid-first-name" type="text" placeholder="John"  v-model="user.first_name">
                </div>
            </div>


            <div class="-mx-3 md:flex mb-6">

                <div class="md:w-1/2 px-3 mb-6 md:mb-0">
                    <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="grid-last-name">
                        Last Name
                    </label>
                    <input class="appearance-none block w-full bg-grey-lighter text-grey-darker border border-red rounded
                     py-3 px-4 mb-3" id="grid-last-name" type="text" placeholder="Doe" v-model="user.last_name">

                </div>

                <div class="md:w-1/2 px-3">
                    <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="grid-other-name">
                        Other Name
                    </label>
                    <input class="appearance-none block w-full bg-grey-lighter text-grey-darker border border-grey-lighter
                     rounded py-3 px-4" id="grid-other-name" type="text" placeholder="Alake" v-model="user.other_name">
                </div>
            </div>


            <div class="-mx-3 md:flex mb-6">

                <div class="md:w-1/2 px-3 mb-6 md:mb-0">
                    <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="grid-email">
                        Email
                    </label>
                    <input class="appearance-none block w-full bg-grey-lighter text-grey-darker border
                    rounded py-3 px-4 mb-3" id="grid-email" type="email" placeholder="JohnDoe@alake.com" v-model="user.email">

                </div>

                <div class="md:w-1/2 px-3">
                    <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="grid-occupation">
                        Occupation
                    </label>
                    <input class="appearance-none block w-full bg-grey-lighter text-grey-darker border border-grey-lighter
                     rounded py-3 px-4" id="grid-occupation" type="text" placeholder="Teacher" v-model="user.occupation">
                </div>
            </div>

            <div class="-mx-3 md:flex mb-6">

                <div class="md:w-1/2 px-3 mb-6 md:mb-0">
                    <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="grid-phone">
                        Phone number
                    </label>
                    <input class="appearance-none block w-full bg-grey-lighter text-grey-darker border border-red rounded
                     py-3 px-4 mb-3" id="grid-phone" type="text" placeholder="09000123453" v-model="user.phone_number">

                </div>

                <div class="md:w-1/2 px-3">
                    <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="grid-address">
                        Address
                    </label>
                    <input class="appearance-none block w-full bg-grey-lighter text-grey-darker border border-grey-lighter
                    rounded py-3 px-4" id="grid-address" type="text" placeholder="10, WAEC Rd, London" v-model="user.home_address">
                </div>
            </div>


            <div class="-mx-3 md:flex mb-2">
                <div class="md:w-1/2 px-3 mb-6 md:mb-0">
                    <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="grid-gender">
                        Gender
                    </label>
                    <div class="relative">
                        <select class="block appearance-none w-full bg-grey-lighter border border-grey-lighter
                        text-grey-darker py-3 px-4 pr-8 rounded" id="grid-gender" v-model="user.gender">
<!--                            <option>Select one</option>-->
                            <option value="female">Female</option>
                            <option value="male">Male</option>
                        </select>
                    </div>
                </div>

                <div class="md:w-1/2 px-3 mb-6 md:mb-0">
                    <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="grid-bday">
                        Birthday
                    </label>
                    <div class="relative">
                        <input class="w-full border rounded p-2 outline-none focus:shadow-outline" type="date"
                               name="date" id="grid-bday" placeholder="YYYY-MM-DD" v-model="user.birthday">
                    </div>
                </div>

                <div class="md:w-1/2 px-3">
                    <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="grid-gender">
                        Marital Status
                    </label>
                    <div class="relative">
                        <select class="block appearance-none w-full bg-grey-lighter border border-grey-lighter text-grey-darker
                        py-3 px-4 pr-8 rounded" id="grid-marital-status" v-model="user.marital_status">
                            <option value="Single">Single</option>
                            <option value="Married">Married</option>
                            <option value="Divorced">Divorced</option>
                            <option value="Widowed">Widowed</option>
                        </select>
                    </div>
                </div>
            </div>

            <button class="bg-blue-500 hover:bg-green-700 text-white uppercase text-sm font-semibold px-10 py-2 mt-6 rounded">Save</button>

        </div>

    </div>
</template>

<script>
import Axios from 'axios';
    export default {
        name: "EditDetails",
        data: function(){
            return {
                user: {},

            }
        },
        methods: {
            getInfo: function(){
                let token = localStorage.getItem('token');
                console.log(token);
                if(token === null){
                    this.$router.push('/');
                    this.$swal('Kindly login');
                }else{
                    Axios.get('/api/info',
                        {headers: {'Content-Type': 'application/json', 'Authorization': `Bearer ${token}`}}
                    ).then(response => {
                        if(response.data.status){
                            this.user = response.data.user;
                        }
                    })
                }
            }
        },
        created() {
            this.getInfo();
        }
    }
</script>

<style scoped>

</style>
